import Vue from "vue";
import GeolocationPopup from './GeolocationPopup';

Vue.config.productionTip = false
let vueEl;

initGeolocationPopupComponent();

function initGeolocationPopupComponent() {
  vueEl = new Vue({
    el: '#geolocation-popup',
    components: {
      GeolocationPopup
    }
  });
}

window.updateGiftboxComponent = initGeolocationPopupComponent;